import WebConfig from 'middlewares/WebConfig';
import store from "../index";

type DownloadOptions = {
  fileNameOverride?: string;
  completeCallback?: () => void;
}

const download = (url: string, method: string, json: string = null, options: DownloadOptions = null, headers: HeadersInit = null) => {
  if (headers === null) {
    headers = {};
  }

  if (json !== null)
    headers["Content-Type"] = "application/json";

  const request: RequestInit = {
    method: method,
    headers: headers,
    credentials: "include",
  };

  if (json !== null)
    request.body = json;

  fetch(url, request)
  .then(async response => {
    let filename: string = options?.fileNameOverride ?? "downloaded-file.txt";
    
    if (!options?.fileNameOverride) {
      const contentDisposition = response.headers.get("Content-Disposition");

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
    }

    const blob = await response.blob();

    const objectUrl: string = window.URL.createObjectURL(blob);
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(objectUrl);

    options?.completeCallback?.();
  })
  .catch(async reason => {
    options?.completeCallback?.();
  });
};

/**
 * Helper to download a file from webapi. Respects content disposition response header for file naming.
 * @param url URL path segment to call
 * @param method HTTP Method
 * @param json stringified json post body, if applicable
 * @param options options, overrides, callbacks
 */
export const webApiDownloadFile = (url: string, method: string = "GET", json: string = null, options: DownloadOptions = null) => {
  if (!url.startsWith(WebConfig.webApiRoot)) {
    let urlBuilder = WebConfig.webApiRoot;
    
    if (!url.startsWith("/")) {
      urlBuilder += "/"
    }

    urlBuilder += url;
    url = urlBuilder;
  }

  const headers: HeadersInit = {
    "Authorization": `Bearer ${store.getState().user.profile.token}`,
  };

  download(url, method, json, options, headers);
};

/**
 * Helper to download a file from phoenix. Respects content disposition response header for file naming. Only works on endpoints that do not require token auth.
 * @param url URL path segment to call
 * @param method HTTP Method
 * @param json stringified json post body, if applicable
 * @param options options, overrides, callbacks
 */
export const phoenixDownloadFile = (url: string, options: DownloadOptions = null) => {
  if (!url.startsWith(WebConfig.phoenixUrl)) {
    let urlBuilder = WebConfig.phoenixUrl;
    
    if (!url.startsWith("/")) {
      urlBuilder += "/"
    }

    urlBuilder += url;
    url = urlBuilder;
  }

  download(url, "GET", null, options);
};
